import { render, staticRenderFns } from "./Documents.vue?vue&type=template&id=3cabed62&scoped=true"
import script from "@/views/Documents/Documents.ts?vue&type=script&lang=ts&external"
export * from "@/views/Documents/Documents.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Documents/documents.scss?vue&type=style&index=0&id=3cabed62&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabed62",
  null
  
)

export default component.exports